/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_Cta_PaidInputs */

const en_platform_pricing_cta_paid = /** @type {(inputs: Platform_Pricing_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free, upgrade later`)
};

const pl_platform_pricing_cta_paid = /** @type {(inputs: Platform_Pricing_Cta_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij bezpłatnie, przejdź wyżej później`)
};

/**
* | output |
* | --- |
* | "Start free, upgrade later" |
*
* @param {Platform_Pricing_Cta_PaidInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_cta_paid = /** @type {((inputs?: Platform_Pricing_Cta_PaidInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_Cta_PaidInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_cta_paid(inputs)
	return en_platform_pricing_cta_paid(inputs)
});